import React from 'react';
import Helmet from 'react-helmet';
import { Watch } from 'scrollmonitor-react';

import purpose from '../components/About/assets/purpose.svg';
import {
  textContainer,
  wideContainer,
  removePaddingBottom,
  center,
} from '../styles';
import Happy from 'react-icons/lib/io/android-happy';
import Animated from '../components/Animated';

const About = ({ isInViewport }) => (
  <div>
    <Helmet
      title="About lucastswick"
      description="How do I know which pixels to put where?"
    />
    <div {...wideContainer} {...removePaddingBottom}>
      <img src={purpose} alt="what a funny looking bald guy" />
    </div>
    <div {...textContainer}>
      <Animated as="h1">About Me</Animated>
      <Animated>
        I’m a generative artist writing algorithms that describe natural
        phenomena. I study patterns and forms from the natural world and write
        mathematical equations that recreate them. Each equation accepts a
        multitude of parameters, and by choosing random parameters, my programs
        create many variations, ranging from highly abstract versions to
        impressively chaotic manifestations of the original idea.
      </Animated>
      <Animated as="h2">Vision</Animated>
      <Animated>
        At the moment, we have more data than we know what to do with, but it's
        not terribly accessible and requires diligence and experience to make
        sense of.
      </Animated>
      <Animated>
        <i>
          The vision for my work is to collaborate with Data Scientists to
          create art that makes data more approachable and understandable
        </i>.
      </Animated>
      <Animated as="h2">Mission</Animated>
      <Animated>
        With my history of engineering and Technical Direction, I’m part of the
        engineering crowd, but I also write music and film music videos,
        woodwork, and am part of the artist crowd. Those two groups rarely come
        together, because their motivations and values can be in opposition.
        It’s important to bring those people together because there are
        engineers writing lines of code that will literally affect billions of
        people’s experiences.
      </Animated>
      <Animated>
        Without connecting those engineers to anthropologists who look
        backwards, philosophers who look inwards, and artists who look upwards,
        the progress we create will be not be aligned with who we are and who we
        can be.
      </Animated>
      <Animated>
        It’s important to me as a human being in this world to bring people
        together, and this is why I create art rooted in meaning.
      </Animated>
      <div {...center}>
        <Animated as="div">
          <Happy color="#F772D7" size={90} />
        </Animated>
      </div>
    </div>
  </div>
);

export default Watch(About);



// WEBPACK FOOTER //
// ./src/pages/About.js